import React from 'react'

export default function Navbar() {
  return (
    <nav className="bg-transparent border-b border-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-end items-center h-12">
          {/* Navigation moved to header */}
        </div>
      </div>
    </nav>
  )
}
